import { API } from "services/api";

export type CreateUpsPickupPayload = {
  pickupDate: string;
  readyTime: string;
  closeTime: string;
  countryCode: string;
  stateCode: string;
  city: string;
  postalCode: string;
  addressLine1: string;
  neighborhood?: string;
  contactName: string;
  phone: string;
  packageCount?: number;
  totalWeight?: number;
  serviceCode?: string;
  specialInstructions?: string;
};

export const postUpsPickup = async (payload: CreateUpsPickupPayload) => {
  const response = await API.post("/api/ups/pickup", payload);
  return response.data;
};